@if (isOpen && isVisible) {
  <!--
    The overlay, panel, backdrop and entry animation come from the library
    modal. What stays here is this dialog's own content: the brand chip, the
    progress card and the two-up footer. Geometry is mapped onto the library's
    tokens in the stylesheet.
  -->
  <aio-modal
    [open]="true"
    [showClose]="false"
    [closeOnEscape]="false"
    ariaLabel="We're building something great for you"
    (closed)="handleGotIt()"
  >
    <div class="coming-soon-modal__top-row">
      <div class="coming-soon-modal__icon-bg" aria-hidden="true">
        <img src="assets/icons/coming_soon_icon.svg" alt="" class="coming-soon-modal__brand-icon" width="19" height="19" />
      </div>
      <button type="button" class="coming-soon-modal__close" (click)="handleGotIt()" aria-label="Close modal">
        <img src="assets/icons/close.svg" alt="" />
      </button>
    </div>

    <h2 class="coming-soon-modal__title">
      We're building something <span class="coming-soon-modal__title-accent">great</span> for you
    </h2>
    <p class="coming-soon-modal__subtitle">
      This feature is currently under development and will be available soon. You'll have access the moment it's
      ready.
    </p>

    <div class="coming-soon-modal__progress-card">
      <div class="coming-soon-modal__progress-header">
        <span class="coming-soon-modal__progress-label">Development Progress</span>
        <span class="coming-soon-modal__progress-pct">75%</span>
      </div>
      <div class="coming-soon-modal__progress-track" aria-hidden="true">
        <div class="coming-soon-modal__progress-fill"></div>
      </div>
      <p class="coming-soon-modal__progress-status">
        This feature is <strong>on track</strong> and actively progressing.
      </p>
    </div>

    <p class="coming-soon-modal__contact">
      Questions? Reach out to us at
      <a class="coming-soon-modal__email" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
    </p>

    <div aioModalFooter class="coming-soon-modal__footer">
      <button type="button" class="coming-soon-modal__btn-got-it" (click)="handleGotIt()">Got it!</button>
      <button type="button" class="coming-soon-modal__btn-notify" (click)="handleNotifyMe()">
        Notify Me When It's Ready
      </button>
    </div>
  </aio-modal>
}
